
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import DraggableOrder from '@/components/draggable-order/Index.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  LabelIconCategoryModel,
  LabelIconCategoryPageSearchModel,
  LabelIconCategorySearchModel,
  LabelIconCategoryAddModel,
  LabelIconCategoryUpdateModel,
  LabelIconCategoryUpdateOrderListModel,
  LabelIconCategoryUpdateOrderModel,
  IdsModel
} from '@/model/product/LabelIconCategoryModel'
import {
  pageSearchLabelIconCategory,
  addLabelIconCategory,
  updateLabelIconCategory,
  removeLabelIconCategory,
  batchRemoveLabelIconCategory,
  updateLabelIconCategoryOrder,
  searchLabelIconCategory
} from '@/apis/product/labelIconCategory'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    DraggableOrder,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      { prop: 'categoryName', label: t('labelIconCategory.categoryName'), placeholder: t('labelIconCategory.categoryNameP'), component: 'el-input', type: 'text', model: null }
      // { prop: 'categoryOrder', label: t('labelIconCategory.categoryOrder'), placeholder: t('labelIconCategory.categoryOrderP'), component: 'el-input', type: 'number', model: null }
    ]

    const createStruct = [
      { prop: 'categoryName', label: t('labelIconCategory.categoryName'), placeholder: t('labelIconCategory.categoryNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'categoryOrder', label: t('labelIconCategory.categoryOrder'), placeholder: t('labelIconCategory.categoryOrderP'), component: 'el-input', type: 'number', model: null }
    ]

    const updateStruct = [
      { prop: 'categoryName', label: t('labelIconCategory.categoryName'), placeholder: t('labelIconCategory.categoryNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'categoryOrder', label: t('labelIconCategory.categoryOrder'), placeholder: t('labelIconCategory.categoryOrderP'), component: 'el-input', type: 'number', model: null }
    ]

    const labelIconCategoryRole = {
      categoryName: [{ required: true, message: t('labelIconCategory.categoryName').concat(t('common.isRequired')), trigger: 'blur' }],
      categoryOrder: [{ required: true, message: t('labelIconCategory.categoryOrder').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'categoryName', label: t('labelIconCategory.categoryName'), sortable: 'custom' },
      { prop: 'categoryOrder', label: t('labelIconCategory.categoryOrder'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: LabelIconCategoryModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: LabelIconCategoryModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const orderStruct = { id: 'id', name: 'categoryName', order: 'categoryOrder' }
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as LabelIconCategorySearchModel,
      tableData: Array<LabelIconCategoryModel>(),
      updateOrderList: Array<LabelIconCategoryModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'labelIconCategory.edit',
        create: 'labelIconCategory.create',
        updateOrder: 'labelFrameCategory.updateOrder'
      },
      dialogFormVisible: false,
      labelIconCategoryRole: labelIconCategoryRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as LabelIconCategoryAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as LabelIconCategoryUpdateModel,
      editRow: {} as LabelIconCategoryModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: LabelIconCategoryPageSearchModel = {
          categoryName: dataMap.searchFormModel.categoryName,
          categoryOrder: dataMap.searchFormModel.categoryOrder,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchLabelIconCategory(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: LabelIconCategoryAddModel = {
          categoryName: dataMap.createModel.categoryName,
          categoryOrder: dataMap.createModel.categoryOrder
        }
        const result = await addLabelIconCategory(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: LabelIconCategoryUpdateModel = {
          id: dataMap.updateModel.id,
          categoryName: dataMap.updateModel.categoryName,
          categoryOrder: dataMap.updateModel.categoryOrder
        }
        const result = await updateLabelIconCategory(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeLabelIconCategory(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveLabelIconCategory(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.categoryName = dataMap.editRow.categoryName
        dataMap.updateModel.categoryOrder = dataMap.editRow.categoryOrder
      },
      createReset() {
        console.log('create reset')
      },
      async updateOrder() {
        if (dataMap.updateOrderList.length < 1) {
          ElMessage({
            message: t('common.noData'),
            type: 'error',
            duration: 2000
          })
          return
        }
        const param: LabelIconCategoryUpdateOrderListModel = {
          list: Array<LabelIconCategoryUpdateOrderModel>()
        }
        dataMap.updateOrderList.forEach(item => {
          param.list.push({ id: item.id, categoryOrder: item.categoryOrder })
        })
        const result = await updateLabelIconCategoryOrder(param)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateOrderReset() {
        console.log('update order reset')
      }
    })
    const handleEditOrder = async() => {
      dataMap.dialogStatus = 'updateOrder'
      dataMap.updateOrderList = []
      const params: LabelIconCategorySearchModel = {
        categoryName: null,
        categoryOrder: null
      }
      const results = await searchLabelIconCategory(params)
      if (results?.data) {
        dataMap.updateOrderList = results.data
        dataMap.dialogFormVisible = true
      } else {
        console.log(results?.message)
        ElMessage({
          message: t('common.noData'),
          type: 'error',
          duration: 2000
        })
      }
    }
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: LabelIconCategoryModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.categoryName = row.categoryName
        dataMap.updateModel.categoryOrder = row.categoryOrder
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      handleEditOrder,
      orderStruct,
      ...toRefs(dataMap)
    }
  }
})
